module.exports = __webpack_public_path__ + "img/programme4.525dac21.png";